<script setup>
import { changePresOffline, OffLinePre_BySerialNumberOrId } from '@/api/workPlace/prescription'
import { BASE_LABEL, columnTable } from './config'
import { defineProps, ref, reactive, defineEmits, onMounted } from 'vue'
import { calcDiagnosis } from '@/utils/index'
import moment from 'moment'
import { isPlanOrVisitMethods } from '@/hooks/globalApi'
const props = defineProps({
  // 处方编号
  serialNumber: {
    type: String,
    default: ''
  },
  // 线下处方ID
  id: {
    type: String,
    default: ''
  },
  mode: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['jumpTo', 'noDetail'])
// 渲染基本信息
const columnsBase = ref([...BASE_LABEL])
// 修改的活动id
const activityTemplateId = ref(0)
// 加载中
const loading = ref(false)
// 渲染数据
const info = reactive({
  // 基本信息
  base: {},
  // 处方图片
  drugs: [],
  // 活动信息
  active: [],
  option: [],
  // 判断随访新老数据
  visitPageType: null
})
// 患者是否可见标识
const patientIsSee = require('@/assets/img/work-place/see-not.png')

// 根据 props 确定请求方式
const calcQueryByProps = () => {
  return props.serialNumber
    ? { serialNumber: props.serialNumber }
    : { prescriptionOfflineId: props.id }
}

// 计算结束时间
const calcEndData = (s, interval) => {
  if (!s) return '--'
  if (!interval) return s || '--'
  return moment(s).add(interval, 'days').format('YYYY-MM-DD')
}

function calcOfflineUpload(record) {
  const role = ['系统', '患者', '医生', 'BD', '医生助手', '合作医院', 'cms', '医生学生']
  const type =
    record.uploaderType || record.uploaderType === 0 ? `${role[record.uploaderType]} - ` : ''
  return `${type}${record.uploader || '未知'}`
}
//如果处方图片有就拼接处方图片
function connectPrescriptionImages(res) {
  //如果处方图片有就拼接处方图片
  const { prescriptionPicUrls = null, imgUrls = [] } = res
  if (prescriptionPicUrls && prescriptionPicUrls.length > 0) {
    return imgUrls.concat(prescriptionPicUrls)
  } else {
    return imgUrls && imgUrls.length > 0 ? imgUrls : []
  }
}
// 查询处方详情
function getDetail() {
  loading.value = true
  info.active.splice(0)
  console.log()
  console.log('线下处方详情params==》', calcQueryByProps())
  OffLinePre_BySerialNumberOrId(calcQueryByProps())
    .then(result => {
      info.base = result
      info.base.imgUrls = connectPrescriptionImages(result)
      info.active = (result.activityInfoVO && [result.activityInfoVO]) || []
      info.drugs = result.prescriptionPicUrls
      info.option = result.activityTemplateInfos
    })
    .catch(() => {
      emit('noDetail', '', props.serialNumber)
    })
    .finally(() => {
      loading.value = false
    })
}

onMounted(() => {
  getDetail()
  isPlanOrVisitMethods({ serialNumber: props.serialNumber }, res => {
    if (res.dateFlg) {
      info.visitPageType = res.dateFlg ? 1 : 2
    }
  })
})

function jumpTo(is, id) {
  if (info.visitPageType !== 1) {
    // 判断是否是新的数据
    emit('jumpTo', is, id)
  }
}
// 修改活动
function changeActive() {
  changePresOffline(info.base.prescriptionId, activityTemplateId.value).finally(() => getDetail())
}
</script>

<template>
  <div class="offline">
    <a-spin :spinning="loading">
      <!-- <div class="patientIsSee" v-if="info.base.patientPermission === 0">
        <auth-img mode='ant' :preview="false" :width="124" :height="44" :src="patientIsSee" />
      </div> -->
      <div class="annotation">
        <span>处方ID：{{ info.base.serialNumber || '--' }}</span>
        <span>上传时间：{{ info.base.createdAt || '--' }}</span>
        <span>
          上传人：
          <label>{{ calcOfflineUpload(info.base) }}</label>
        </span>
      </div>
      <h3 class="baseTitle">基本信息</h3>
      <div class="detail_info">
        <div
          class="detail_info-item"
          v-for="column in columnsBase"
          :class="[column.class, { nopadding: column.nopadding, noborder: column.noborder }]"
          :key="column"
        >
          <label class="item_label">{{ column.label }}：</label>
          <!-- 关联随访计划 -->
          <span v-if="column.prop === 'followupPlanIds'" class="item_content">
            <template v-if="info.base.followupPlanIds && info.base.followupPlanIds.length">
              <span
                :class="[info.visitPageType !== 1 ? 'link_content' : '']"
                v-for="(it, index) in info.base.followupPlanIds"
                :key="it"
                @click="jumpTo('visit', it)"
              >
                {{ it }}
                <span v-if="info.base.followupPlanIds.length !== index + 1">,</span>
              </span>
            </template>
            <span v-else>--</span>
          </span>
          <!-- 临床诊断 -->
          <span v-else-if="column.prop === 'diagnosisInfoList'" class="item_content">
            {{ calcDiagnosis(info.base, 'diagnosisInfoList', 'diagnosis') }}
          </span>
          <span v-else-if="column.type === 'img'" class="item_content imgLabel">
            <ul class="img-block" v-if="info.base[column.prop]?.length">
              <li
                class="img-block_item"
                v-for="(src, index) in info.base[column.prop]"
                :key="index"
              >
                <auth-img mode="ant" width="100%" height="100%" :src="src" class="img-block_img" />
              </li>
            </ul>
            <span v-else>--</span>
          </span>
          <span v-else-if="column.prop === 'calcEndDate'" class="item_content">
            {{ calcEndData(info.base.purchaseTime, info.base.medicineCycle) }}
          </span>
          <span v-else-if="column.render" class="item_content">
            {{ column.render(info.base[column.prop], info.base) }}
          </span>
          <!-- default -->
          <span v-else class="item_content">
            {{ info.base[column.prop] || '--' }}
          </span>
        </div>
      </div>
      <!-- 活动信息 -->
      <div class="detail_table">
        <h3 class="detail_table-title">活动信息</h3>
        <a-table
          :transformCellText="({ text }) => text ?? '--'"
          :rowKey="(record, index) => index"
          :pagination="false"
          :dataSource="info.active"
          :columns="columnTable"
          :scroll="{ y: 560, x: '100%' }"
        >
          <template #activityTemplateName="{ record }">
            <!--
              NOTE:修改只能改一次
              如果有关联随访计划，那么不显示修改按钮
            -->
            <div v-if="info.base.daModifyFlag === 0 && !info.base.followUpPlanId">
              <a-select
                class="activity-select"
                v-model:value="record.activityTemplateName"
                @change="(v, option) => (activityTemplateId = option.key)"
              >
                <a-select-option
                  v-for="option in info.option"
                  :key="option.id"
                  :value="option.activityTemplateName"
                >
                  {{ option.activityTemplateName }}
                </a-select-option>
              </a-select>
              <a-popconfirm
                title="活动名称仅允许修改一次，确定修改吗？"
                ok-text="确定"
                cancel-text="取消"
                @confirm="changeActive"
              >
                <a-button type="primary">修改</a-button>
              </a-popconfirm>
            </div>
            <div v-else>{{ record.activityTemplateName }}</div>
          </template>
        </a-table>
      </div>
    </a-spin>
  </div>
</template>

<style lang="scss" scoped>
.offline {
  position: relative;
  font-family: PingFangSC-Medium;
  .patientIsSee {
    position: absolute;
    right: 0;
    top: 35px;
  }
  .annotation {
    text-align: right;
    line-height: 25px;
    color: #999999;
    font-weight: 400;
    span {
      margin-left: 28px;
    }
  }
  .baseTitle {
    font-size: 16px;
    font-weight: 550;
    color: #000000;
    margin-bottom: 25px;
  }

  // 信息展示
  .detail_info {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    grid-template-rows: repeat(2, minmax(44px, auto));
    list-style: none;
    margin: 0;
    padding-left: 0;
    grid-gap: 5px 0;
    position: relative;
    margin-bottom: 30px;
    &-item {
      font-size: 14px;
      padding: 20px 0 20px 16px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e8e8e8;
      // 第一列左对齐
      &.nopadding {
        padding-left: 0;
      }
      // 最后一列不要边框
      &.noborder .item_content:after {
        width: 0;
      }
      .item_label {
        font-weight: 550;
        flex-shrink: 0;
        margin-right: 3px;
        color: #999999;
      }
      .item_content {
        font-weight: 400;
        color: #666666;
        flex: auto;
        width: 80%;
        position: relative;
        z-index: 2;
        font-weight: bold;
        &:after {
          content: '';
          display: block;
          width: 1px;
          background: #e8e8e8;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
        .determine {
          padding: 2px 8px;
          background: #1890ff;
          border-radius: 4px;
          border-radius: 2px;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .link_content {
        color: #1890ff;
        cursor: pointer;
      }
      .img_content {
        overflow: hidden;
        .recordImg {
          margin: 0 12px 0;
          overflow: hidden;
        }
      }
      &.large {
        // 左边框所在网格线
        grid-column-start: 1;
        // 右边框所在网格线
        grid-column-end: 4;
      }
    }
    // .sLabel {
    //   width: 25%;
    // }

    // .mLabel {
    //   width: 33.3%;
    // }
    // .lLabel {
    //   width: 100%;
    // }
  }

  // 底部药品信息
  .detail_table {
    margin-bottom: 30px;
    padding: 10px 0;
    .detail_table-title {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
    }
    .activity-select {
      width: 75%;
    }
  }
  .imgLabel {
    .img-title {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
    }
    .img-block {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-top: 8px;

      .img-block_item {
        width: 140px;
        height: 120px;
        margin: 0 12px 12px 0;
        ::v-deep(.ant-image) {
          overflow: hidden;
        }
        ::v-deep(.ant-image-img) {
          object-fit: cover;
        }
      }
    }
  }
}
</style>
